import { gql } from '@apollo/client';
export const StatFeatureStaffHoursApproval = gql `
    fragment StatFeatureStaffHoursApproval on StaffHoursApprovalFeatureSettingsResult {
        enabledForAll
        canToggleForAll
    }
`;
